import React from "react";
import * as PropTypes from "prop-types";
import { PickerBase } from "mui-daterange-picker-plus/dist";
import type { DateRange } from "mui-daterange-picker-plus/dist";
import { formatDateRange } from "../../util/date-helper";
import { Box, Typography } from "@mui/material";

DateRangePicker.propTypes = {
  dateRange: PropTypes.arrayOf(PropTypes.object).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default function DateRangePicker(props: any) {
  // Convert from array format [startDate, endDate] to object format {startDate, endDate}
  const dateRangeObject: DateRange = {
    startDate: props.dateRange[0] ? new Date(props.dateRange[0]) : undefined,
    endDate: props.dateRange[1] ? new Date(props.dateRange[1]) : undefined,
  };

  const handleChange = (range: DateRange) => {
    // Convert back to array format for compatibility with existing code
    // Ensure we always return Date objects (not dayjs/moment objects)
    const startDate = range.startDate instanceof Date
      ? range.startDate
      : new Date(range.startDate || props.dateRange[0]);
    const endDate = range.endDate instanceof Date
      ? range.endDate
      : new Date(range.endDate || props.dateRange[1]);
    props.onChange([startDate, endDate]);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <Typography variant="h6" sx={{ mb: 2 }}>
        {formatDateRange(props.dateRange[0], props.dateRange[1])}
      </Typography>
      <PickerBase
        initialDateRange={dateRangeObject}
        onChange={handleChange}
      />
    </Box>
  );
}
